import "../application.css";
import { createApp } from "../app";
import { installClientCrashReporter } from "../lib/clientCrashReporter";

installClientCrashReporter();
createApp();
